import useWindowDimensions from "hooks/useWindowDimensions";
import React from "react";
import MobileMenu from "components/layout/MobileMenu";
import { MemoizedHeader as DefaultHeader } from "components/layout/headers/default";
import SidebarMenu from "components/layout/sidebarMenu";
import { sidebarMenuItems } from "../sidebarMenu/menuItems";
import "./index.css";

export default function RootLayout({
  children,
  Header,
}: {
  children: any;
  Header?: any;
}) {
  const dimention = useWindowDimensions();

  return (
    <>
      <div className="dashboard">
        <SidebarMenu navItems={sidebarMenuItems} />
        <div className="dashboard-container">
          {Header ? <Header /> : <DefaultHeader />}
          {children}
        </div>
      </div>

      {dimention.width <= 1024 && (
        <>
          <MobileMenu />
          <div className="filldown"></div>
          <div className="background"></div>
        </>
      )}
    </>
  );
}
